import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/siteData";

const categoryMap: Record<string, string> = {};
categories.forEach((c) => {
  categoryMap[c.id] = c.name;
});

export default function Breadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);

  const breadcrumbItems = paths.map((path, index) => {
    const url = `/${paths.slice(0, index + 1).join("/")}`;
    let label = "";

    if (index === 0 && path === "category") {
      label = "分类";
    } else if (index === 1 && paths[0] === "category") {
      label = categoryMap[path] || path;
    } else if (index === 0 && path === "article") {
      label = "文章";
    } else if (index === 1 && paths[0] === "article") {
      label = "阅读";
    } else if (path === "about") {
      label = "关于我们";
    } else {
      label = path;
    }

    return { label, url };
  });

  const structuredItems = [
    { "@type": "ListItem", position: 1, name: "首页", item: (typeof window !== "undefined" ? window.location.origin : "") + __BASE_PATH__ + "/" },
    ...breadcrumbItems.map((item, idx) => ({
      "@type": "ListItem" as const,
      position: idx + 2,
      name: item.label,
      item: (typeof window !== "undefined" ? window.location.origin : "") + __BASE_PATH__ + item.url,
    })),
  ];

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-3 px-4 md:px-6 max-w-7xl mx-auto w-full">
        <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
          首页
        </Link>
        {breadcrumbItems.map((item, idx) => (
          <span key={item.url} className="flex items-center">
            <span className="mx-2 text-foreground-400">/</span>
            {idx === breadcrumbItems.length - 1 ? (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
            ) : (
              <Link to={item.url} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            )}
          </span>
        ))}
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: structuredItems,
          }),
        }}
      />
    </>
  );
}